export default __webpack_public_path__ + "static/media/ico-sq-17-partnership.55db8652.svg";